function RefundTable() {
  return (
    <>
      <div>
        <div className="br mb-5 mt-3"></div>
        <div className="h4">
            七、退費金額計算表
        </div>
      </div>
      <p>依前項服務進度計算之退費金額如下：</p>

      <div className="table-responsive mb-4">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>服務進度階段</th>
              <th>狀態說明</th>
              <th>乙方保留比例</th>
              <th>非 Becker Taiwan 學員退費金額</th>
              <th>Becker Taiwan 學員優惠退費金額</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>A</td><td>乙方尚未開始任何媒合、轉介、資料整理、資料提供予背書人或其他服務流程</td><td>0%</td><td>8,000 元</td><td>4,000 元</td></tr>
            <tr><td>B</td><td>乙方已開始行政處理、資格初步確認、資料整理或背書人搜尋，但尚未將甲方資料提供予背書人閱覽或評估</td><td>10%</td><td>7,200 元</td><td>3,600 元</td></tr>
            <tr><td>C</td><td>乙方已將甲方 CV、考試通過證明、工作經驗摘要或其他必要資料提供予背書人閱覽或評估</td><td>15%</td><td>6,800 元</td><td>3,400 元</td></tr>
            <tr><td>D</td><td>背書人已閱覽甲方資料，且已與甲方進行文字、電子郵件、通訊軟體或其他方式之初步接洽，但尚未進行 interview</td><td>20%</td><td>6,400 元</td><td>3,200 元</td></tr>
            <tr><td>E</td><td>甲方與背書人已預約 interview，但尚未進行；或因甲方臨時取消、改期、未依約提供資料、未完成背書人要求之準備事項或其他可歸責於甲方之事由，致 interview 無法如期進行</td><td>25%</td><td>6,000 元</td><td>3,000 元</td></tr>
            <tr><td>F</td><td>甲方與背書人已完成 interview，惟背書人認定無法進行背書或不適合簽署</td><td>30%</td><td>5,600 元</td><td>2,800 元</td></tr>
            <tr><td>G</td><td>背書人已表示願意進行背書或簽署，惟甲方自行放棄、未提供後續文件、未完成申請表、未配合背書流程、未於本方案有效期間內完成必要安排，或因其他可歸責於甲方之事由導致背書程序無法完成</td><td>100%</td><td>不退費</td><td>不退費</td></tr>
            <tr><td>H</td><td>甲方提供之資料、文件、聲明或上傳內容有不實、不完整、無效、無法證明、偽造、變造、冒用、重大遺漏或重大誤導之情形</td><td>100%</td><td>不退費</td><td>不退費</td></tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

function AppendixTable() {
  return (
    <>
      <div className="br mb-5 mt-3"></div>
      <div className="h4">附件一：方案服務內容規格表</div>

      <div className="table-responsive mb-4">
        <table className="table table-bordered">
          <tbody>
            <tr><th style={{ width: "30%" }}>服務項目</th><th>內容</th></tr>
            <tr><td>方案名稱</td><td>Becker CPA 工作經驗背書簽字服務方案</td></tr>
            <tr><td>適用對象</td><td>已通過美國 CPA 考試，欲申請美國 CPA Active License 取得執業權利者</td></tr>
            <tr><td>方案效期</td><td>三個月，自清款後收到購買確認信當日起算</td></tr>
            <tr><td>方案價格</td><td>非 Becker Taiwan（捷進顧問）學員：新臺幣 8,000 元<br />Becker Taiwan（捷進顧問）學員優惠：新臺幣 4,000 元</td></tr>
            <tr><td>會計師背書協助服務</td><td>一次；乙方協助媒合或轉介持有美國 CPA 執照之背書人，後續由甲方與背書人直接進行背書準備與確認</td></tr>
            <tr><td>購買必要資料</td><td>本人 CV、美國 CPA 考試通過證明、至少一年會計產業工作經驗聲明、資料真實有效聲明</td></tr>
            <tr><td>不保證事項</td><td>不保證取得背書、不保證執照核發、不保證轉州成功、不保證台灣會計師考試抵免成功</td></tr>
            <tr><td>使用限制</td><td>僅限甲方本人使用，不得轉讓、轉售、出借、共用或提供第三人使用</td></tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default function ContractCPAWorkExp({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
    const contractText = `捷進顧問有限公司（Becker Taiwan）
「Becker CPA 工作經驗背書簽字服務方案」
購買契約暨同意事項說明書


一、契約審閱期間與當事人資料
甲方得於購買前審閱本契約全部條款內容至少五日。甲方於 Becker Taiwan 指定購買頁面勾選「我已閱讀並同意本契約暨同意事項」並完成付款程序前，應確認已完整審閱本契約、方案規格、購買須知、隱私權政策及相關服務規定。
立契約書人
甲方：購買者／學員
乙方：捷進顧問有限公司（Becker Taiwan）
負責人：陸秀麗
客服電子郵件：service@beckertw.com
營業所地址：臺北市大安區信義路四段 6 號 16 樓之 12
統一編號：8052-3352
甲乙雙方就甲方購買乙方提供之「Becker CPA 工作經驗背書簽字服務方案」相關權利義務，訂定本契約。
二、本方案名稱、適用對象與服務性質
本方案名稱為「Becker CPA 工作經驗背書簽字服務方案」（以下簡稱「本方案」）。
本方案適用對象為已通過美國 CPA（Certified Public Accountant）考試，並欲申請美國 CPA Active License、取得執業權利之購買者。
本方案包含媒合服務。乙方提供之說明，係依官方公開資訊、官方指定認證單位、官方考試單位、各州發照單位資訊及乙方過往實務經驗進行一般性說明與經驗分享，不構成法律、移民、稅務、會計師執照核發保證，亦不構成任何官方審查結果之承諾。
本方案不包含代辦服務。所有申請文件之準備、提交、追蹤、補件、繳費、官方往來及最終申請結果，均由甲方自行負責。
三、本方案內容
甲方購買本方案後，於本契約約定之有效期間內，得依本契約規定取得下列服務：
美國 CPA 執照申請所需之會計師背書（work experience verification）協助服務，一次。
本方案之實際服務項目、使用方式、開通程序、可使用期間及限制，除本契約另有明確約定外，均以本契約、購買頁面、購買確認信及乙方另行公告之服務規定為準。前開文件如有不一致者，應依有利於甲方之解釋或適用。
四、購買前必要條件、表單資料與甲方聲明
甲方購買本方案時，應於購買表單完成下列事項：
上傳甲方本人之個人工作 CV。
上傳甲方本人已通過美國 CPA 考試之證明文件。
勾選同意並保證甲方本人已持有至少一年之會計產業工作經驗。
勾選同意並保證甲方提供之全部資料、文件、聲明及上傳內容均為真實、正確、完整、有效且未經偽造、變造或冒用。
前項所稱「至少一年之會計產業工作經驗」，包括下列範圍：
會計師事務所工作經驗。
稅務事務所工作經驗。
業界財務會計相關工作經驗。
學界會計教學或研究人員經驗。
政府單位會計人員經驗。
甲方瞭解並同意，若甲方未具備至少一年適用之會計產業工作經驗，或所提供之 CV、考試通過證明、工作經驗資料或其他文件有不實、不完整、無效、無法證明、偽造、變造或冒用情形，致使後續無法取得背書、無法提出執照申請、申請遭駁回、遭官方要求補件或發生其他不利益者，相關責任及風險均由甲方自行承擔。乙方及背書人不因此負補償、賠償或保證申請成功之責任；退費事宜應依本契約第七條「退費、服務進度扣款與背書資格不符之處理」辦理。
五、契約成立、生效與方案有效期間
甲方經由網際網路購買本方案者，於乙方指定頁面勾選「我已閱讀並同意本契約暨同意事項」並再次確認購買內容後，本契約成立。
本契約自甲方完成付款，且乙方確認款項入帳後生效。
本方案有效期間為3個月，自甲方完成清款並收到乙方寄發之「購買確認信」當日起算。
本方案內所有服務，均應於本方案有效期間內預約、開通、領取或使用。甲方未於有效期間內使用之服務，於有效期間屆滿時自然失效，甲方不得要求延長、轉讓、保留至其他方案、折抵現金、退費或其他補償。
若任一服務另有規定之開通期限或使用期限，甲方亦應遵守該等規定；如該等規定與本方案一年有效期間不同，應以較早屆滿者為甲方可使用該項服務之最後期限，除非乙方另以書面或電子郵件明確通知較有利於甲方之安排。
六、會計師背書（work experience verification）協助服務
（一）服務次數與服務完成定義
本方案提供會計師背書協助服務一次。
本項服務係指乙方協助甲方媒合或轉介一位持有美國 CPA 執照之背書人，並協助雙方交換聯絡方式，使甲方得依背書人要求進行適當背書準備流程。
本項服務之目標，係協助甲方經乙方轉介認識一位持有美國 CPA 執照之背書人，並依背書人要求進行合理必要之背書準備流程，以促成背書人在執照申請表上工作經驗背書欄位簽字。惟甲方是否最終取得背書，仍取決於甲方工作經驗、文件完整性、背書人專業判斷及相關州別規定；如因甲方條件、資料或其他不可歸責於乙方之事由致無法取得背書者，應依本契約第七條辦理。
若甲方未依背書人要求提供文件、未能證明適用工作經驗、無法完成背書人合理要求之確認程序、未於方案有效期間內配合聯繫或安排，或因甲方不符購買時親自聲明保證持有之個人條件、導致背書程序無法完成，相關結果由甲方自行負責。
（二）甲方工作經驗與文件真實性義務
甲方購買本方案時，已聲明並保證本人具備至少一年適用之會計產業工作經驗。
甲方應提供真實、正確、完整且可供合理查核之 CV、工作經驗說明、職稱、任職期間、工作內容、主管或雇主資訊及美國 CPA 考試通過證明。
若背書人或乙方於服務過程中發現甲方工作經驗明顯不足、不屬於適用範圍、資料無法證明、內容不一致、疑似不實、偽造、變造或有其他不適合背書之情形，背書人得拒絕背書或要求補充資料。甲方不得因此向乙方請求補償、賠償或要求另行保證取得背書；退費事宜應依本契約第七條「退費、服務進度扣款與背書資格不符之處理」辦理。
（三）乙方與背書人之角色分工
乙方之責任為協助甲方媒合適當背書人並交換聯絡方式。
完成媒合後，背書相關對話、文件確認、工作內容確認、執照狀態確認、身分確認、背書意願與是否簽署，均由甲方與背書人直接討論及負責。
背書人得依其專業判斷、執照州別規定、倫理規範及個人風險控管要求，請甲方提供工作經驗證明、履歷、主管聯繫方式、工作內容說明、面談、聲明書或其他資料。甲方應自行決定是否提供並承擔資料提供之相關責任。
乙方不介入背書人之專業判斷，不要求背書人為不實背書，不保證背書人必然同意簽署，也不保證背書內容必然符合任何州別之最終審查要求。
（四）官方審核與結果不保證
實際審核甲方申請文件並決定是否核發執照之權責機關，為美國各州會計師委員會（State Board of Accountancy）及其他相關官方單位。
乙方及背書人均非最終審核及發照機構。
乙方及背書人不對甲方執照申請結果作任何明示或默示保證，包括但不限於：取得背書、通過官方審查、執照核發、Active License 取得、轉州成功、抵免台灣會計師考試成功或申請時程長短。
七、退費、服務進度扣款與背書資格不符之處理
甲方瞭解並同意，本方案為「會計師背書（work experience verification）協助服務」之媒合與轉介服務，非屬補習、教學、課程或教育服務型態，亦非保證取得背書、保證背書人簽署、保證執照申請通過或保證任何州別主管機關審查結果之服務。
甲方完成付款後，乙方始啟動本方案服務流程，包括但不限於資料初步確認、行政處理、背書人搜尋、媒合、轉介、提供甲方資料予背書人閱覽或評估、安排甲方與背書人接洽，以及協助雙方進入背書準備流程。甲方未完成付款前，不得要求乙方開始媒合背書人、提供背書人聯絡方式、安排與背書人文字接洽、預約 interview 或進入其他本方案服務流程。
若甲方於付款後，經乙方或背書人審閱其 CV、工作經驗說明、美國 CPA 考試通過證明或其他相關資料後，認定甲方工作經驗不足、工作內容不屬於適用範圍、資料無法證明、內容不一致、文件不完整，或有其他不適合進行背書之情形，致本方案背書程序無法繼續進行者，乙方得依本條約定辦理部分退費。甲方不得因此主張乙方應保證另行媒合其他背書人、保證取得背書、全額退費、補償或賠償。
本方案退費金額應依服務進度、已發生成本、背書人投入時間、乙方行政處理成本及雙方可歸責事由計算。除依法令另有強制規定或可歸責於乙方之事由外，乙方得依下列標準計算應保留金額及應退還金額：
甲方於購買後申請解除契約，且乙方尚未開始任何媒合、轉介、資料整理、資料提供予背書人或其他服務流程者，乙方不扣除任何費用，甲方已支付之方案價金全額退還。
乙方已開始行政處理、資格初步確認、資料整理或背書人搜尋，但尚未將甲方資料提供予背書人閱覽或評估者，乙方得保留方案價金百分之十，其餘百分之九十退還甲方。
乙方已將甲方 CV、考試通過證明、工作經驗摘要或其他必要資料提供予背書人閱覽或評估者，乙方得保留方案價金百分之十五，其餘百分之八十五退還甲方。
背書人已閱覽甲方資料，且已與甲方進行文字、電子郵件、通訊軟體或其他方式之初步接洽，但尚未進行 interview 者，乙方得保留方案價金百分之二十，其餘百分之八十退還甲方。
甲方與背書人已預約 interview，但尚未進行；或因甲方臨時取消、改期、未依約提供資料、未完成背書人要求之準備事項或其他可歸責於甲方之事由，致 interview 無法如期進行者，乙方得保留方案價金百分之二十五，其餘百分之七十五退還甲方。
甲方與背書人已完成 interview，惟背書人基於其專業判斷、執照州別規定、倫理規範、個人風險控管要求或甲方工作經驗與文件狀況，認定無法進行背書或不適合簽署者，乙方得保留方案價金百分之三十，其餘百分之七十退還甲方。
背書人已表示願意進行背書或簽署，惟甲方自行放棄、未提供後續文件、未完成申請表、未配合背書流程、未於本方案有效期間內完成必要安排，或因其他可歸責於甲方之事由導致背書程序無法完成者，乙方得保留方案價金百分之一百，甲方不得請求退費。
甲方提供之資料、文件、聲明或上傳內容有不實、不完整、無效、無法證明、偽造、變造、冒用、重大遺漏或重大誤導之情形者，乙方得終止本契約並保留方案價金百分之一百；若因此造成乙方、背書人或第三人損害，甲方並應負相關法律責任。
本方案價格如下：
非 Becker Taiwan（捷進顧問）學員：新臺幣八千元整。
Becker Taiwan（捷進顧問）學員優惠：新臺幣四千元整。


退費金額係以甲方實際支付之方案價金為計算基礎。如甲方適用其他優惠、折扣或專案價格，乙方得依甲方實際付款金額，按本條所列保留比例計算退費金額。
退費方式原則上以匯款方式辦理，乙方得請甲方提供本人帳戶資料。退費所需之匯款手續費、跨行手續費或其他金融機構收取之必要費用，得自退費金額中扣除；但依法令不得扣除者，不在此限。
八、帳號、個人資訊、電子郵件與通知
甲方使用本方案相關服務所需之購買確認信、開通通知、預約通知、補件要求、方案變更通知及其他重要資訊，乙方得以電子郵件、購買頁面、會員系統、LINE 官方帳號或乙方指定方式通知甲方。
甲方應提供可正常收信且有效期限足以涵蓋本方案有效期間之 E-mail，並自行定期收信、檢查垃圾郵件匣及維持聯絡資料正確。
因甲方未更新聯絡資料、未收信、信箱容量不足、郵件遭擋信、未查看通知或其他不可歸責於乙方之事由，導致權益受影響者，由甲方自行負責。
甲方應妥善保管其帳號、密碼、序號及登入資訊。以甲方帳號密碼登入或使用服務者，推定為甲方本人行為；但如甲方能證明係不可歸責於甲方之第三人非法使用，雙方應依本契約及相關法令處理。
九、設備規格與使用環境
甲方使用本方案之線上服務、Google Meet、或其他網際網路服務時，應自行備妥符合服務平台要求之設備、作業系統、瀏覽器、網路連線、攝影機、麥克風及文件檢視工具。
其餘未列示之軟硬體、作業系統、瀏覽器、裝置或系統環境，乙方不保證其通訊品質、登入穩定性或完整功能支援。甲方連結乙方指定網站系統之接取網路，除經雙方另有明確約定由乙方提供者外，應由甲方自行向合法電信或網路服務業者申請租用，相關權利義務依甲方與該業者間契約處理。
十、個人使用、禁止轉讓與智慧財產權
本方案所有服務、帳號、背書媒合服務、文件範本及其他資料，均限甲方本人依本契約目的使用。
未經乙方事前書面同意，甲方不得將本方案之全部或一部權利轉讓、轉售、贈與、出租、出借、分享、提供予第三人使用，亦不得以任何方式使第三人取得本方案利益。
甲方不得對乙方提供之內容、範本、翻譯資料、網站畫面或其他內容進行錄音、錄影、截圖、翻拍、重製、散布、公開傳輸、改作、販售或其他侵害智慧財產權之行為。但平台明確允許下載或保存之資料，不在此限，惟仍限甲方本人合理使用。
甲方違反本條約定者，應自負一切法律責任；乙方得依違約情節暫停或終止提供服務，並依法請求損害賠償。
十一、服務品質、系統異常與第三方平台
乙方應提供具有合理期待安全性之服務，並就可歸責於乙方之系統錯誤、畫面暫停、遲滯、中斷、不能連線或其他服務品質瑕疵，依本契約及相關法令處理。
乙方因可歸責於自己之事由，致甲方無法使用本方案服務者，乙方應儘速更正或修復，並依服務性質，以延長使用期間、另行安排、補發資料或其他合理方式補償甲方。
若服務品質瑕疵係因 Google Meet、網路服務業者、甲方設備、甲方網路、不可抗力或其他不可歸責於乙方之第三方因素所致，乙方將於合理範圍內協助甲方排除或向第三方反映，但不保證第三方平台之持續可用性、內容不變或系統不發生異常。
乙方對於本服務相關軟硬體設備進行必要搬遷、更換、升級、保養或維修時，得暫停本服務之全部或一部。
十二、個人資料蒐集、處理及利用
甲方同意乙方為提供本方案服務、確認購買資格、安排媒合背書人、聯繫通知、客服處理、申訴處理、內部紀錄、行銷、調查、統計、研究分析及依法保存契約資料之目的，於必要範圍內蒐集、處理及利用甲方個人資料。
依個人資料保護法第八條第一項，乙方向甲方告知下列事項：
蒐集目的：包括但不限於 040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務，以及本方案履行所必要之相關目的。
個人資料類別：包括但不限於 C001 電子郵件、中文姓名、英文拼音全名、電話號碼；C002 金融機構帳戶號碼與姓名；C003 身分證字號或護照號碼；C036 是否曾訂購本公司產品、得知本公司之管道；C038 在職身分；C051 所屬或畢業學校與科系；以及甲方提供之 CV、工作經驗、考試通過證明、申請州別、購買紀錄及其他為履行本方案所必要之資料。
個人資料利用期間與地區：於甲方使用乙方服務期間、契約保存期間、依法令或業務執行所必要期間，於乙方營業所在地、服務提供地及完成本方案所必要之地區利用。
個人資料利用對象及方法：乙方將依甲方填寫之訂購資料確認訂購、提供學員管理、客服、行銷活動、申訴處理、統計分析及本方案相關服務。乙方亦得於必要範圍內將資料提供予支付或金流服務提供者、系統服務提供者、背書人或其他為履行本方案所必要之合作對象。
在未經甲方同意或非依法令、契約履行必要範圍之情形下，乙方不會將甲方個人資料提供予第三人或作不當利用。
甲方瞭解並同意，為執行會計師背書協助服務，乙方可能需將甲方姓名、聯絡方式、CV、考試通過證明、工作經驗摘要或其他甲方同意提供之必要資料提供予潛在背書人，以利背書人評估是否進行背書程序。乙方及背書人均應於本方案目的必要範圍內使用該等資料。
甲方得依個人資料保護法第三條規定，就其個人資料向乙方請求查詢、閱覽、製給複製本、補充、更正、停止蒐集處理利用或刪除；如欲行使權利，得來信 service@beckertw.com。
若甲方拒絕提供或未能提供正確完整之必要資料，乙方可能無法確認購買資格或進行背書媒合，相關不利益由甲方自行承擔。
十三、授權使用費與付款方式
本方案授權使用費如下，均含營業稅：
非 Becker Taiwan（捷進顧問）學員：新臺幣八千元整。
Becker Taiwan（捷進顧問）學員優惠：新臺幣四千元整。
甲方是否適用 Becker Taiwan（捷進顧問）學員優惠價格，應以乙方系統紀錄、購買紀錄、學員身分確認結果、購買頁面、報價單、發票或購買確認信所載內容為準。
付款方式為一次全部繳納，除乙方另行書面同意外，甲方應於購買當日或乙方指定期限內完成付款。
乙方確認款項入帳後，始寄發購買確認信並啟動本方案後續服務流程。
如乙方另提供優惠、折扣、加價購、贈品或其他促銷方案，該等內容應以購買當時乙方明示之條件為準，並應作為本契約之一部分。
十四、契約終止、服務期間與期滿效果
甲方得依相關法令及本契約約定通知乙方終止本契約。乙方不得以本契約條款排除或限制甲方依法享有之解除權、終止權或退費權。
本方案為會計師背書媒合與轉介服務，非屬補習、教學、課程或教育服務型態。甲方完成付款後，乙方始啟動本方案服務流程；本方案如涉及非以有形媒介提供之線上服務或一經提供即為完成之服務部分，並經甲方事前知悉及同意後提供者，應依本契約、第七條及相關法令辦理契約解除、終止及退費事宜。
甲方一經開始使用本方案服務，包括但不限於乙方開始行政處理、資格初步確認、資料整理、背書人搜尋、媒合、轉介、提供甲方資料予背書人閱覽或評估、安排甲方與背書人接洽、預約或進行 interview，或協助雙方進入背書準備流程後，即屬服務已開始提供或成本已發生。除依法令或可歸責於乙方之事由外，退費應依本契約第七條所定服務進度、扣款比例及退費方式辦理。
甲方於本方案有效期間內依法或依本契約約定提前終止契約者，雙方應依本方案服務項目之性質、服務進度、已安排或已執行事項、背書人已投入時間及雙方可歸責事由，並依本契約第七條所定扣款比例與退費方式，辦理契約終止結算。
本方案為固定期間制之服務方案，方案價金係對應甲方於有效期間內取得本方案服務使用資格，而非以甲方實際取得背書、完成簽字或取得美國 CPA 執照為必要。服務提供狀態之認定，包含但不限於下列事項：
會計師背書協助服務：乙方已進行行政處理、資格初步確認、資料整理、背書人搜尋、媒合、轉介、交換聯絡方式、提供必要溝通、安排接洽、預約 interview，或協助甲方與背書人進入背書準備程序者，得依其進度認定服務已提供。
本方案有效期間僅作為甲方得使用本方案服務之期間限制，不另作為本契約第七條退費扣款比例以外之獨立扣款依據。
本方案有效期間屆滿時，甲方尚未使用或尚未使用完畢之服務資格，均隨期間屆滿而自然失效。期滿後，乙方不負保留、展延、折抵、移轉、替換、轉換現金或辦理期滿後價金結算之義務。但因可歸責於乙方之事由致甲方無法於有效期間內使用服務，或法令另有強制規定者，不在此限。
如契約提前終止係因可歸責於甲方之事由所致，乙方得依本契約第七條所定服務進度、扣款比例及退費方式辦理結算；但不得逾相關法令所允許之範圍。
退費方式原則上以匯款方式辦理，乙方得請甲方提供本人帳戶資料。退費期限依雙方約定及相關法令辦理。
甲方如有違反強制或禁止規定、公序良俗、智慧財產權、禁止轉讓分享規範，或違反本契約經乙方定合理期間通知改正仍未改正者，乙方得終止本契約。若甲方自行或因可歸責於己之事由終止契約，且服務已開始使用者，除依法令另有規定外，應依本契約第七條及本條約定辦理退費或不予退費。
十五、不可抗力
因天災、戰爭、暴動、疫情、政府命令、法令變更、罷工、網路重大故障、第三方平台重大異常、官方政策變更或其他不可抗力事件，致本契約全部或一部無法履行者，雙方得協議展延、替代履行、部分終止或全部終止。契約終止時，乙方應依已提供服務比例及相關法令辦理結算。
十六、申訴與客服
甲方對於乙方所提供之本方案服務，如有疑問、異議或申訴，得以電子郵件 service@beckertw.com 或乙方公告之其他方式聯繫乙方。乙方應自接獲甲方申訴之日起十五日內妥適處理或回覆處理進度。
十七、契約附件與效力
本契約、購買頁面、方案規格表、購買確認信、購買須知、乙方公告之服務規範及乙方廣告，均為本契約之一部分。
前項文件如有與本契約條款牴觸者，應為有利於甲方之適用。
本契約成立時，乙方應將本契約及相關附件提供甲方下載儲存，或依甲方請求以電子文件方式提供。
本契約保存期間為五年。
十八、契約解釋、準據法與管轄法院
本契約條款如有疑義，應依中華民國法律及消費者保護相關法令解釋；如有疑義且涉及定型化契約條款，應為有利於甲方之解釋。
因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院。但不得排除消費者保護法第四十七條、民事訴訟法第四百三十六條之九或其他法律所定消費者得主張之管轄法院適用。

`;

    const renderLine = (line, index) => {
        const text = line.trim();

        if (!text) {
            return <div key={index} className="mb-3"></div>;
        }

        if (index === 0 || text === "購買契約暨同意事項說明書") {
            return (
                <div key={index} className="text-center mb-2">
                    {text}
                </div>
            );
        }

        if (text === "「Becker CPA 工作經驗背書簽字服務方案」") {
            return (
                <div key={index} className="text-center mb-2">
                    {text}
                </div>
            );
        }

        if (/^（[一二三四五六七八九十]+）/.test(text)) {
            return <div key={index} className="h5 mt-4">{text}</div>;
        }

        return <p key={index} className="mb-2">{text}</p>;
    };

    return (
        <div className="container mb100 mt100">
            <div className="beckertitlename mb100 mt100">
                Becker CPA 工作經驗背書簽字服務方案
            </div>

            <div className="card w-75 p-5 m-auto">
                <h5 className="card-title text-black text-center">
                    購買契約暨同意事項說明書
                </h5>

                <div className="br mb-5 mt-3"></div>

                <div className="card-body">
                    <div className="card-text m-auto">
                        {contractText.split("\n").map(renderLine)}

                        <RefundTable />

                        <AppendixTable />
                    </div>

                    <div className="text-center">
                        <label>
                            <input
                                className="m-2"
                                type="checkbox"
                                value="read"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                required
                            />
                            <span>我已詳閱並且了解</span>
                        </label>

                        <div
                            className="btn btn-primary m-3"
                            onClick={handleNextButtonClick}
                        >
                            下一步
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
